export function saveToLocalStorage(key, value) {
    localStorage.setItem(key, value);
}